module.exports = __webpack_public_path__ + "img/40_38_071_450.086d6a48.jpg";